import type { WsLink } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { Link } from "@/store/types";

function transformWsLink(r: WsLink): Link {
  return {
    id: r.id,
    contentId: r.contentId,
    url: r.url,
    description: r.description ?? null,
    title: r.title ?? null,
    image: r.image ?? null,
    linkOrder: r.linkOrder ?? 0,
  };
}

export async function bulkUpsertLink(records: WsLink[]) {
  if (records.length === 0) return;
  store.upsert("link", records.map(transformWsLink));
}
